/**
 * Abstração única do data source.
 *
 * Produção usa `real` (chama o backend .NET via /api).
 * Dev/demo usa `mock` (fixtures coerentes com schema real).
 *
 * Troca sem rewrite de componente.
 */

import type { DocsGrowthClient } from "./types";
import { mockClient } from "./mock";

export type { DocsGrowthClient };

const source = import.meta.env.VITE_DATA_SOURCE ?? "mock";

export const client: DocsGrowthClient = source === "real"
  ? (await import("./real")).realClient
  : mockClient;
